export default __webpack_public_path__ + "static/fblike-1a517a4f418cad195e31ec87055368b2.png";